<app-website-header></app-website-header>
<app-carousel></app-carousel>
<div class="product">
    <img src="../../assets/images/icons/home-icon.svg" alt="" [routerLink]="['/']">
    <div [routerLink]="['/']">Home /</div>
    <div [routerLink]="['/products-view']" [state]="{isViewAll:isViewAll}"> Products</div>
    <div class="product-count-inner">
      Total Products: {{customersCount}}
  </div>

</div>

<div class="heading-with-line">
    <div class="line1"></div>
    <div class="heading-text" style="font-weight: 600;font-size:18; font-family: 'Georgia' !important;">Categories</div>
    <div class="line2"></div>
</div>
<div class="card">
    <ng-container *ngFor="let product of products">

        <div class="categories col-12 col-sm-6 col-md-6 col-lg-2 mb-4">
            <app-product-info-card
            [id]="product.id"
              [productImage]="product.image"
              [title]="product.title"
              [subcategories]="product.subcategories"
              [productCount]="product.productCount"
              [isCategoryCard]="true"
              [isViewAll]="this.isViewAll">
            </app-product-info-card>
          </div>
      </ng-container>
  </div>
  
<app-website-footer></app-website-footer>